import PropTypes from 'prop-types';

const LoadingSpinner = ({ size = 'medium', message }) => {
  const sizeClasses = {
    small: 'spinner-border-sm',
    medium: '',
    large: 'spinner-border spinner-border-lg',
  };

  return (
    <div className="d-flex flex-column align-items-center justify-content-center py-5">
      <div
        className={`spinner-border text-primary ${sizeClasses[size]}`}
        role="status"
        aria-label="Loading"
      >
        <span className="visually-hidden">Loading...</span>
      </div>
      {message && (
        <p className="mt-3 text-muted" aria-live="polite">
          {message}
        </p>
      )}
    </div>
  );
};

LoadingSpinner.propTypes = {
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  message: PropTypes.string,
};

export default LoadingSpinner;
